import React from 'react';
import {
    Dialog,
    Grid,
    Typography,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const CrearDocumento = ({ open, onClose }) => {
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
        >
            <Grid
                container
                direction="column"
                sx={{ height: '100vh' }}
            >
                {/* =========================
                    HEADER FIJO
                ========================= */}
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        px: 3,
                        py: 2,
                        bgcolor: '#0f2a2a',
                        color: 'white'
                    }}
                >
                    <Button
                        variant="contained"
                        color="error"
                        onClick={onClose}
                    >
                        Cancelar
                    </Button>

                    <Typography fontWeight={600}>
                        Crear documento
                    </Typography>

                    <Button
                        variant="contained"
                        color="success"
                    >
                        Guardar
                    </Button>
                </Grid>

                {/* =========================
                    CONTENIDO
                ========================= */}
                <Grid
                    container
                    direction="column"
                    sx={{
                        p: 3,
                        overflowY: 'auto',
                        flexGrow: 1
                    }}
                >

                    {/* INFO */}
                    <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        sx={{ mb: 2 }}
                    >
                        <InfoOutlinedIcon fontSize="small" />
                        <Typography fontWeight={600}>
                            Información
                        </Typography>
                    </Grid>

                    <Typography fontWeight={600} sx={{ mb: 2 }}>
                        Información obligatoria
                    </Typography>

                    {/* =========================
                        FORMULARIO
                    ========================= */}
                    <Grid container spacing={2}>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <TextField
                                label="Nombre"
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Empresas / Clientes</InputLabel>
                                <Select>
                                    <MenuItem value="San Alfonso">
                                        San Alfonso
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo</InputLabel>
                                <Select>
                                    <MenuItem value="Opcional">
                                        Opcional
                                    </MenuItem>
                                    <MenuItem value="Obligatorio">
                                        Obligatorio
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo de firma</InputLabel>
                                <Select>
                                    <MenuItem value="Firma electrónica">
                                        Firma electrónica
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Privacidad</InputLabel>
                                <Select>
                                    <MenuItem value="Público">
                                        Público
                                    </MenuItem>
                                    <MenuItem value="Privado">
                                        Privado
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Entidades</InputLabel>
                                <Select>
                                    <MenuItem value="Personas">
                                        Personas
                                    </MenuItem>
                                    <MenuItem value="Carpetas">
                                        Carpetas
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Añadir por defecto</InputLabel>
                                <Select defaultValue="Sí">
                                    <MenuItem value="Sí">Sí</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel>Carpeta por defecto</InputLabel>
                                <Select>
                                    <MenuItem value="">—</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};
